import { z } from "zod";

export const getVehicleLocationsResponseSchema = z.array(
  z.object({
    lat: z.number(),
    lon: z.number(),
    date: z.iso.datetime(),
  }),
);

export type GetVehicleLocationsResponse = z.infer<
  typeof getVehicleLocationsResponseSchema
>;
